   <div class="card mt-4">
        <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbHome"></p-breadcrumb>
    </div>

<div class="card mt-4">

<!-- <p-toolbar styleClass="mb-6">
            <ng-template #start>
                <p-button label="Ajouter DO" icon="pi pi-plus" severity="secondary" class="mr-2" />
            </ng-template>
</p-toolbar> -->
<div class="font-semibold text-xl mb-4">Liste des DO</div>
   <p-table
                #dt
                [value]="do"
                dataKey="code_interne"
                [rows]="10"
                [loading]="loading"
                [rowHover]="true"
                [showGridlines]="true"
                [paginator]="true"
                [globalFilterFields]="['code_interne', 'Nom', 'Activite', 'MultiLangue', 'MissionPA']"
                responsiveLayout="scroll"
                [tableStyle]="{ 'min-width': '75rem' }"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} do"
                [showCurrentPageReport]="true"
                [selectionMode]="'single'"
                [(selection)]="selectedDo"
                (onRowSelect)="onRowSelect($event)"
                [rowsPerPageOptions]="[10, 20, 30, 40, 50, 60, 70 , 80, 90, 100]"
              
        >
            <ng-template #caption>
                <div class="flex items-center justify-between">
                      <button pButton label="Réintialiser" class="p-button-outlined mb-2" icon="pi pi-filter-slash"
                       (click)="clear(dt)"></button>
                    <p-iconfield>
                        <p-inputicon styleClass="pi pi-search" />
                        <input pInputText type="text" (input)="onGlobalFilter(dt, $event)" placeholder="Rechercher..." />
                    </p-iconfield>
                </div>
            </ng-template>
            <ng-template #header>
                <tr>
                    <th pSortableColumn="code_interne" style="min-width: 4rem">
                         <div class="flex justify-between items-center">
                        Code DO
                         <p-columnFilter type="text" field="code_interne" display="menu" placeholder="Rechercher par astreinte"></p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="Nom" style="min-width:16rem">
                         <div class="flex justify-between items-center">
                        Nom
                         <p-columnFilter type="text" field="Nom" display="menu" placeholder="Rechercher par astreinte"></p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="Activite" style="min-width: 8rem">
                         <div class="flex justify-between items-center">
                        Activite
                         <p-columnFilter type="text" field="Activite" display="menu" placeholder="Rechercher par astreinte"></p-columnFilter>
                         </div>
                    </th>
                    <th pSortableColumn="MultiLangue" style="min-width:8rem">
                        <div class="flex justify-between items-center">
                        MultiLangue
                         <p-columnFilter type="text" field="MultiLangue" display="menu" placeholder="Rechercher par astreinte"></p-columnFilter>
                       </div>
                    </th>
                    <th pSortableColumn="MissionPA" style="min-width: 8rem">
                        <div class="flex justify-between items-center">
                        MissionPA
                         <p-columnFilter type="text" field="MissionPA" display="menu" placeholder="Rechercher par astreinte"></p-columnFilter>
                        </div>
                    </th>
                </tr>
            </ng-template>
            <ng-template #body let-doItem>
                <tr [pSelectableRow]="doItem">
                    <td style="min-width: 12rem">{{ doItem.code_interne }}</td>
                    <td style="min-width: 16rem">{{ doItem.Nom }}</td>
                    <td style="min-width: 8rem">{{  doItem.Activite }}</td>
                    <td style="min-width: 10rem">{{ doItem.MultiLangue }}</td>
                    <td style="min-width: 12rem">{{ doItem.MissionPA }}</td>
                </tr>
            </ng-template>
            <ng-template #emptymessage>
                    <tr>
                        <td colspan="8">Aucun DO trouvé.</td>
                    </tr>
            </ng-template>
            <ng-template #loadingbody>
                    <tr>
                        <td colspan="8">Chargement des données DO. Veuillez patienter.</td>
                    </tr>
            </ng-template>
        </p-table>

        <!-- <p-dialog [(visible)]="doDialog" [style]="{ width: '450px' }" header="Product Details" [modal]="true">
            <ng-template #content>
                <div class="flex flex-col gap-6">
                    <img [src]="'https://primefaces.org/cdn/primeng/images/demo/product/' + product.image" [alt]="product.image" class="block m-auto pb-4" *ngIf="product.image" />
                    <div>
                        <label for="name" class="block font-bold mb-3">Name</label>
                        <input type="text" pInputText id="name" [(ngModel)]="product.name" required autofocus fluid />
                        <small class="text-red-500" *ngIf="submitted && !product.name">Name is required.</small>
                    </div>
                    <div>
                        <label for="description" class="block font-bold mb-3">Description</label>
                        <textarea id="description" pTextarea [(ngModel)]="product.description" required rows="3" cols="20" fluid></textarea>
                    </div>

                    <div>
                        <label for="inventoryStatus" class="block font-bold mb-3">Inventory Status</label>
                        <p-select [(ngModel)]="product.inventoryStatus" inputId="inventoryStatus" [options]="statuses" optionLabel="label" optionValue="label" placeholder="Select a Status" fluid />
                    </div>

                    <div>
                        <span class="block font-bold mb-4">Category</span>
                        <div class="grid grid-cols-12 gap-4">
                            <div class="flex items-center gap-2 col-span-6">
                                <p-radiobutton id="category1" name="category" value="Accessories" [(ngModel)]="product.category" />
                                <label for="category1">Accessories</label>
                            </div>
                            <div class="flex items-center gap-2 col-span-6">
                                <p-radiobutton id="category2" name="category" value="Clothing" [(ngModel)]="product.category" />
                                <label for="category2">Clothing</label>
                            </div>
                            <div class="flex items-center gap-2 col-span-6">
                                <p-radiobutton id="category3" name="category" value="Electronics" [(ngModel)]="product.category" />
                                <label for="category3">Electronics</label>
                            </div>
                            <div class="flex items-center gap-2 col-span-6">
                                <p-radiobutton id="category4" name="category" value="Fitness" [(ngModel)]="product.category" />
                                <label for="category4">Fitness</label>
                            </div>
                        </div>
                    </div>

                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-6">
                            <label for="price" class="block font-bold mb-3">Price</label>
                            <p-inputnumber id="price" [(ngModel)]="product.price" mode="currency" currency="USD" locale="en-US" fluid />
                        </div>
                        <div class="col-span-6">
                            <label for="quantity" class="block font-bold mb-3">Quantity</label>
                            <p-inputnumber id="quantity" [(ngModel)]="product.quantity" fluid />
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template #footer>
                <p-button label="Cancel" icon="pi pi-times" text (click)="hideDialog()" />
                <p-button label="Save" icon="pi pi-check" (click)="saveProduct()" />
            </ng-template>
        </p-dialog> -->

        <p-confirmdialog [style]="{ width: '450px' }" />
        
        <!-- button valider la sélection -->
       <div class="flex justify-end mt-3">
            <p-button label="Valider"
            [disabled]="!selectedDo"
            (click)="validerSelection()"
            icon="pi pi-check" styleClass="p-button-primary" />
       </div>   
       
    <p-toast/>
</div>